export enum UserType {
  NotApplicable = 0,
  SuperAdmin = 1,
  Admin = 2,
  School = 3,
  CRT = 4,
}
